import React from "react";
import { motion } from "framer-motion";
import {
  FaGlobe,
  FaClock,
  FaCertificate,
  FaCreditCard,
  FaUser,
  FaChartBar,
  FaDesktop,
  FaLanguage,
} from "react-icons/fa";
import "./ThirdSec.css";

const features = [
  {
    icon: <FaGlobe />,
    badge: "60+ countries",
    title: "Worldwide Recognized",
    text: "Serving since 2020 across USA, UK, Europe, Australia & Canada.",
  },
  {
    icon: <FaClock />,
    badge: "Always open",
    title: "24/7 Service",
    text: "Round-the-clock lessons so students can learn anywhere, anytime.",
  },
  {
    icon: <FaCertificate />,
    badge: "On completion",
    title: "Appraisal Certificate",
    text: "Earn a completion certificate after successful course evaluation.",
  },
  {
    icon: <FaCreditCard />,
    badge: "Secure",
    title: "Seamless Payment",
    text: "Pay securely via credit card, bank transfer, or PayPal.",
  },
  {
    icon: <FaUser />,
    badge: "1-on-1",
    title: "Individual Classes",
    text: "One-to-one sessions tailored to gender and learning preferences.",
  },
  {
    icon: <FaChartBar />,
    badge: "Monthly",
    title: "Evaluation Reports",
    text: "Monthly progress reports from our Quality Control Team.",
  },
  {
    icon: <FaDesktop />,
    badge: "All-in-one",
    title: "Online Panel",
    text: "LMS tracks schedules, lessons, and payments in one place.",
  },
  {
    icon: <FaLanguage />,
    badge: "Multilingual",
    title: "Expert Tutors",
    text: "Arab and non-Arab teachers available in your preferred language.",
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const ThirdSection = () => {
  return (
    <section className="ts-section">
      <div className="ts-header">
        <h2 className="ts-title">Why Choose TaleemulQuran</h2>
        <p className="ts-subtitle">
          Everything you need to learn Quran — from anywhere, at any time.
        </p>
      </div>

      <motion.div
        className="ts-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {features.map((feature, idx) => (
          <motion.div key={idx} className="ts-card" variants={cardVariants}>
            <div className="ts-card-inner">
              <span className="ts-badge">{feature.badge}</span>
              <div className="ts-icon-wrap">{feature.icon}</div>
              <h3 className="ts-card-title">{feature.title}</h3>
              <p className="ts-card-text">{feature.text}</p>
            </div>
            <div className="ts-card-accent" />
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default ThirdSection;